import { EVENTS } from '../../lib/constants';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import HELPERS from '../../lib/globals/helpers/Helpers';
import AnimateEntrance from '../helper/animate';
class SettingsPageController {
	constructor(vc, conf) {
		this.config = conf;
		this.vc = vc;
		this.enabled = false;
		this.timeout = null;
		if (vc) {
			if (this.config.holder) {
				this.vc = vc[this.config.holder];
			} else {
				this.vc = vc[this.config.item];
			}
			AnimateEntrance(vc);
			window.sm.play({ name: 'bonus_buy_quest_open_sfx' });
			this.addEventListeners();
		} else {
			throw new Error(
				'SettingsPageController failed init ' + JSON.stringify(this.config)
			);
		}
	}

	handleEvent(evt) {
		switch (evt.type) {
			case EVENTS.INTERACTION:
				const target = this.vc.getBounds();
				if (
					HELPERS.handleOutsideClick(
						target,
						evt.x,
						evt.y,
						'settings',
						true,
						this.vc
					)
				) {
					this.removeEvents();
				}
				break;
			case EVENTS.MODAL:
				if (evt.detail.modal !== 'settings') {
					this.removeEvents();
				}
				break;
			case EVENTS.ERROR_PAGE:
				this.removeEvents();
				break;
			case EVENTS.BONUS_BUY:
				if (evt.detail.bonus) {
					this.removeEvents();
				}
				break;
			case 'keydown':
				if (evt.keyCode === 27 || evt.keyCode === 32) {
					if (GameConfigs.modal === 'settings') {
						HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: '' });
					}
					this.removeEvents();
				}
				break;
			case EVENTS.SETTINGS_UPDATE:
				if (evt.detail.data.keyboard_shortcuts !== undefined) {
					if (evt.detail.data.keyboard_shortcuts) {
						if (this.enabled) return;
						this.enabled = true;
						window.addEventListener('keydown', this, false);
					} else {
						this.enabled = false;
						window.removeEventListener('keydown', this, false);
					}
				}
				break;
			case EVENTS.REEL_FINISHED:
				if (GameConfigs.win > 0) {
					HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: '' });
					this.removeEvents();
				}
				break;
			default:
				break;
		}
	}

	addEventListeners() {
		window.addEventListener(EVENTS.MODAL, this, false);
		window.addEventListener(EVENTS.BONUS_BUY, this, false);
		window.addEventListener(EVENTS.REEL_FINISHED, this, false);
		window.addEventListener(EVENTS.ERROR_PAGE, this, false);
		window.addEventListener(EVENTS.SETTINGS_UPDATE, this, false);
		if (
			GameConfigs.settings.keyboard_shortcuts &&
			!window.isMobile &&
			!window.isTablet
		) {
			window.addEventListener('keydown', this, false);
			this.enabled = true;
		}
		if (this.timeout) {
			clearTimeout(this.timeout);
		}
		this.timeout = setTimeout(() => {
			//add event after a small delay when the component is rendered
			window.addEventListener(EVENTS.INTERACTION, this, false);
		}, 100);
	}

	removeEvents() {
		window.sm.play({ name: 'bonus_buy_quest_close_sfx' });
		window.removeEventListener(EVENTS.INTERACTION, this, false);
		window.removeEventListener(EVENTS.MODAL, this, false);
		window.removeEventListener(EVENTS.ERROR_PAGE, this, false);
		window.removeEventListener(EVENTS.REEL_FINISHED, this, false);
		window.removeEventListener(EVENTS.BONUS_BUY, this, false);
		window.removeEventListener(EVENTS.SETTINGS_UPDATE, this, false);
		window.removeEventListener('keydown', this, false);
	}
}

export default SettingsPageController;
